import { Logo } from "../components/Logo";
import styled from "styled-components";

const data = [
  {
    ja: "アルファ・チジェン",
    en: "Alpha-thujene",
    value: "0.14%",
    description:
      "アルファ・チジェンは、多種多様な植物に見られる、自然界に存在する有機化合物で、モノテルペンに分類されます。植物の特有の香りを担っています。無色の液体で、水には溶けにくいもののエタノールやジエチルエーテルとは混ざります。",
  },
  {
    ja: "アルファ・ピネン",
    en: "Alpha-pinene",
    value: "0.29%",
    description:
      "アルファ・ピネンはテルペン類の有機化合物で、ピネンの2つの異性体のうちの1つです。不飽和化合物で反応性のある四員環を含んでいます。主に松などの針葉樹の精油、ローズマリーやサトウジャモトキ（一部地域ではZoufaとも呼ばれる）の精油に含まれます。その光学異性体は自然界に存在し、(1S,5S)-または(−)-α-ピネンはヨーロッパの松に多く、(1R,5R)-または(+)-α-異性体は北アメリカに多いです。レース混合物はユーカリ油やオレンジピール油などの一部の油に存在します。",
  },
  {
    ja: "カンフェン",
    en: "Camphene",
    value: "0.17%",
    description:
      "カンフェンは二環式モノテルペンです。水にはほとんど溶けませんが、一般的な有機溶媒にはよく溶けます。室温では容易に揮発し、独特の匂いがあります。ターペンチン、ヒノキ油、カンフォール油、シトロネラ油、ネロリ、ショウガ油、カワラボウキなどの多くの精油の少量成分です。香りをつけるための製剤や食品添加物の調製に使用されます。",
  },
  {
    ja: "サビネン",
    en: "Sabinene",
    value: "0.27%",
    description:
      "サビネンは自然界に存在する二環式モノテルペンで、黒胡椒の辛さやニンジンの種子油の主成分に寄与する化学物質の一つです。ティーツリー油にも存在し、ノルウェースプルース（Picea abies）の果実の油の主要成分でもあります。",
  },
  {
    ja: "ベータ・ピネン",
    en: "Beta-pinene",
    value: "0.06%",
    description:
      "ベータ・ピネンは、植物に見られるモノテルペン、有機化合物であり、ピネンの2つの異性体のうちの1つです。無色の液体で、アルコールには溶けますが、水には溶けません。ウッディーでグリーンな松のような匂いがあります。",
  },
  {
    ja: "オクタン-3-オン",
    en: "Octan-3-one",
    value: "1.31%",
    description:
      "オクタン-3-オン、別名3-オクタノンは、分子式C8H16Oを持つ自然有機化合物です。鋭い、フルーティーな香りのある無色の液体で、香水や風味に使われます。ラベンダーやミントなどの特定の植物の油に自然に含まれています。",
  },
  {
    ja: "ミルセン",
    en: "Myrcene",
    value: "0.80%",
    description:
      "ミルセン、またはβ-ミルセンは、ホップ、カンナビス、ベルベナなどのいくつかの植物の精油の主要成分であるモノテルペンです。ミルシャ（Myrcia）から半合成的に生産され、その名前が由来しています。いくつかの香りの生産における重要な中間体です。α-ミルセンは、構造異性体の2-メチル-6-メチレン-1,7-オクタジエンの名前で、自然界には存在せず、用途はほとんどありません。",
  },
  {
    ja: "リナロール",
    en: "Linalool",
    value: "33.02%",
    description:
      "リナロールは、花やスパイスのような香りを持つ、植物由来の芳香性アルコールです。広く香料や化粧品業界で利用されています。リナロールはまた、抗炎症、抗菌、鎮痛作用があり、アロマセラピーで利用されることがあります。",
  },
  {
    ja: "シトロネロール",
    en: "Citronellol",
    value: "0.19%",
    description:
      "シトロネロールは、シトラス系の香りを持つ芳香性アルコールで、ローズやゼラニウムなどの花の香りを持ちます。香料や化粧品に広く使用されています。",
  },
  {
    ja: "ゲラニオール",
    en: "Geraniol",
    value: "0.16%",
    description:
      "ゲラニオールは、バラやゼラニウムに見られる、花の香りを持つ芳香性アルコールです。香料や化粧品において、花の香りを補完する目的で使用されます。",
  },

  { ja: "3-オクタノール", en: "3-octanol", value: "0.35%" },
  { ja: "アルファ-フェランドレン", en: "Alpha-phellandrene", value: "0.06%" },
  { ja: "ヘキシルアセテート", en: "Hexyl acetate", value: "0.54%" },
  { ja: "デルタ-3-カレン", en: "Delta-3-carene", value: "0.26%" },
  { ja: "アルファ-テルピネン", en: "Alpha-terpinene", value: "0.08%" },
  { ja: "p-シメン", en: "p-cymene", value: "0.14%" },
  {
    ja: "リモネン, ベータ-フェランドレン",
    en: "limonene, beta-phellandrene",
    value: "0.84%",
  },
  { ja: "1,8-シネオール", en: "1,8-cineole", value: "0.99%" },
  {
    ja: "シス-ベータ-オキシメン",
    en: "Cis-beta-ocimene",
    value: "6.24%",
    description:
      "天然に存在する有機化合物で、多くの植物の精油に含まれています。この化合物は、特有の芳香を持ち、香水や化粧品の製造に使用されます。また、一部の昆虫のフェロモンとしても機能します。",
  },
  {
    ja: "トランス-ベータ-オキシメン",
    en: "Trans-beta-ocimene",
    value: "3.19%",
    description:
      "天然に存在する有機化合物で、多くの植物の精油に含まれています。この化合物は、特有の芳香を持ち、香水や化粧品の製造に使用されます。また、一部の昆虫のフェロモンとしても機能します。",
  },
  { ja: "ガンマ-テルピネン", en: "Gamma-terpinene", value: "0.24%" },
  {
    ja: "トランス-リナロールオキシド",
    en: "Trans-linalool oxide",
    value: "0.09%",
  },
  { ja: "テルピノレン", en: "Terpinolene", value: "0.22%" },
  {
    ja: "オクテン-3-イルアセテート",
    en: "Octen-3-yl acetate",
    value: "0.90%",
  },
  { ja: "3-オクチルアセテート", en: "3-octyl acetate", value: "0.14%" },
  { ja: "カンフォール", en: "Camphor", value: "0.29%" },
  {
    ja: "ラヴァンドロール",
    en: "Lavandulol",
    value: "1.02%",
    description:
      "モノテルペンアルコールで、ラベンダーオイルなどのさまざまなエッセンシャルオイルに含まれています。この用語は、2つのエナンチオマー（鏡像異性体）のいずれかを指します。天然の(R)-エナンチオマーは、「弱い花の香り、ハーブの香りで、わずかにレモンのような、新鮮な柑橘系の果実のニュアンス」の香りがあります。一方、(S)-エナンチオマーは弱い香りしかありません。Lavandulolとそのエステルは、香水産業で使用され、昆虫のフェロモンとしても同定されています。",
  },
  { ja: "ボルネオール", en: "Borneol", value: "0.61%" },
  {
    ja: "テルピネン-4-オール",
    en: "Terpinene-4-ol",
    value: "5.72%",
    description:
      "無色の液体で、主に植物のエッセンシャルオイルに存在します。その香りは、ウッディでスパイシーで、しばしばティートリーオイルの主要な成分として知られています。この化合物は、抗菌、抗真菌、抗酸化、抗炎症の特性を持つとされており、そのため、化粧品、パーソナルケア製品、香水、食品、医薬品など、多くの製品で使用されています。",
  },
  {
    ja: "アルファ-テルピネオール",
    en: "Alpha-terpineol",
    value: "1.15%",
    description:
      "無色の液体で、主に植物のエッセンシャルオイルに存在します。その香りは、花やリンゴのような甘い香りで、化粧品、パーソナルケア製品、香水、食品、医薬品など、多くの製品で使用されています。また、抗菌、抗真菌、抗酸化、抗炎症の特性を持つとされています。",
  },
  { ja: "ネラール", en: "Neral", value: "0.06%" },

  {
    ja: "リナリルアセテート",
    en: "Linalyl acetate",
    value: "26.55%",
    description:
      "有機化合物で、リナロールの酢酸エステルです。多くの花やスパイス植物のフィトケミカル（植物化学物質）であり、ベルガモットやラベンダーのエッセンシャルオイルの主要な成分の一つです。リナロールと一緒に存在することがよくあります。広く使用される香料です。",
  },
  { ja: "ボルニルアセテート", en: "Bornyl acetate", value: "0.09%" },
  {
    ja: "ラヴァンジュリルアセテート",
    en: "Lavandulyl acetate",
    value: "3.10%",
    description:
      "lavandulolの酢酸エステルであり、ラベンダーオイルの成分の一つです。",
  },
  { ja: "ネリルアセテート", en: "Neryl acetate", value: "0.32%" },
  { ja: "ゲラニルアセテート", en: "Geranyl acetate", value: "0.51%" },
  {
    ja: "ベータ-カリオフィレン",
    en: "Beta-caryophyllene",
    value: "3.85%",
    description:
      "多くのエッセンシャルオイル、特にクローブオイルの成分である自然な二環式セスキテルペンです。",
  },
  { ja: "アルファ-ヒュムレン", en: "Alpha-humulene", value: "0.15%" },
  {
    ja: "(E)-ベータ-ファルネセン",
    en: "(E)-beta-farnesene",
    value: "3.47%",
    description:
      "この化合物は、リンゴの皮などの果物の皮に存在し、特に緑色のリンゴの特徴的な香りを生み出す要素とされています。",
  },
  { ja: "ジャーマクレンD", en: "Germacrene D", value: "0.41%" },
  { ja: "デルタ-カジネン", en: "Delta-cadinene", value: "0.13%" },
];

const Layout = styled.div`
  text-align: left;
  display: inline-block;
  padding: 20px;
`;

const LogLayout = styled.div`
  text-align: center;
  margin: 60px 0;
`;

const CenterLayout = styled.div`
  padding: 0 0 40px 0;
  @media screen and (min-width: 960px) {
    width: 545px;
  }
`;

const RightLayout = styled(CenterLayout)`
  @media screen and (min-width: 960px) {
    margin: 0 0 0 40px;
    width: 335px;
  }
`;

const NumberData = styled.td`
  padding-top: 20px;
  text-align: left;
  font-weight: bold;
`;

const Description = styled.td`
  padding-bottom: 20px;
  border-bottom: solid 1px #ccc;
`;

const TableHead = styled.th`
  width: 8em;
`;

const TopItemLayout = styled(TableHead)`
  padding-top: 20px;
  word-break: keep-all;
`;

const detail = [
  { title: "原産国", value: "ブルガリア" },
  { title: "抽出部位", value: "花/葉" },
  { title: "抽出方法", value: "水蒸気蒸留法" },
  { title: "学名", value: "Lavandula angustifolia" },
  { title: "科名", value: "シソ科" },
  {
    title: "効果",
    value: "安眠、免疫力強化、肩こり、ニキビ、肌のアンチエイジング、虫除け",
  },
];

export const Lavandula6 = () => (
  <Layout>
    <LogLayout>
      <Logo />
    </LogLayout>
    <CenterLayout>
      <h2>ブルガリア産 ラベンダー</h2>
      <h3>1. 使用期限</h3>
      <p>{new Date("2025-12-31T09:00:00.000Z").toLocaleDateString()}</p>
      <br></br>
      <h3>2. 製品の特徴</h3>
      <table>
        <tbody>
          {detail.map((item, index) => (
            <tr key={index}>
              <TableHead>{item.title}</TableHead>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br></br>
      <br></br>
      <h3>3. 成分</h3>
      <table>
        <tbody>
          {data
            .sort((a, b) => {
              return (
                Number(b.value.replace(/%$/, "")) -
                Number(a.value.replace(/%$/, ""))
              );
            })
            .map((item, index) => (
              <>
                <tr key={index}>
                  <TopItemLayout>{item.ja}</TopItemLayout>
                  <NumberData>{item.value}</NumberData>
                </tr>
                {item.description && (
                  <tr>
                    <Description colSpan={2}>{item.description}</Description>
                  </tr>
                )}
              </>
            ))}
        </tbody>
      </table>
    </CenterLayout>
    <RightLayout></RightLayout>
  </Layout>
);
